import { render, staticRenderFns } from "./FrameMicrosoft.vue?vue&type=template&id=1e6e1574&"
import script from "./FrameMicrosoft.vue?vue&type=script&lang=js&"
export * from "./FrameMicrosoft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports